import React from "react";
import { Link } from "react-router-dom";
import { Facebook, Instagram, Youtube, Twitter } from "lucide-react";
import { FaWhatsapp } from "react-icons/fa";
import { useLanguage } from '../context/LanguageContext';

const Footer = () => {
  const { language } = useLanguage();

  const content = {
    en: {
      navigation: "Navigation",
      home: "Home",
      aboutUs: "About Us",
      institutions: "Institutions",
      policy: "Policy",
      services: "Services",
      schemes: "Schemes",
      
      location: "Location",
      locationAddress: "Registrar of Cooperative Societies, Chetpet, Chennai",
      viewOnMap: "View on Google Maps",
      
      socialMedia: "Social Media",
      twitter: "X",
      instagram: "Instagram",
      youtube: "YouTube",
      facebook: "Facebook",
      whatsapp: "WhatsApp",
      
      copyright: "Copyright © 2025, All Rights Reserved REGISTRAR OF COOPERATIVE SOCIETIES",
      designedBy: "Designed and Developed by",
      visitors: "Total Visitors"
    },
    ta: {
      navigation: "வழிசெலுத்தல்",
      home: "முகப்பு",
      aboutUs: "எங்களைப் பற்றி",
      institutions: "நிறுவனங்கள்",
      policy: "கொள்கை",
      services: "சேவைகள்",
      schemes: "திட்டங்கள்",
      
      location: "இடம்",
      locationAddress: "கூட்டுறவு சங்கங்களின் பதிவாளர், செட்பேட்டை, சென்னை",
      viewOnMap: "கூகுள் மேப்ஸில் பார்க்க",
      
      socialMedia: "சமூக ஊடகம்",
      twitter: "X",
      instagram: "இன்ஸ்டாகிராம்",
      youtube: "யூடியூப்",
      facebook: "பேஸ்புக்",
      whatsapp: "வாட்ஸ்அப்",
      
      copyright: "பதிப்புரிமை © 2025, அனைத்து உரிமைகளும் பாதுகாக்கப்பட்டவை கூட்டுறவு சங்கங்களின் பதிவாளர்",
      designedBy: "வடிவமைக்கப்பட்டு உருவாக்கப்பட்டது",
      visitors: "மொத்த பார்வையாளர்கள்"
    }
  };

  const t = content[language];

  return (
    <footer className="bg-[#006AA5] text-white">
      {/* Main Section */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 py-10 px-8 text-center">
        
        {/* Left - Navigation */}
        <div className="flex flex-col space-y-3 text-left mx-auto">
          <h2 className="font-semibold mb-3">{t.navigation}</h2>
          <Link to="/" className="cursor-pointer hover:underline">{t.home}</Link>
          <Link to="/about-us" className="cursor-pointer hover:underline">{t.aboutUs}</Link>
          <Link to="/dccws" className="cursor-pointer hover:underline">{t.institutions}</Link>
          <Link to="/policy/acts-and-rules" className="cursor-pointer hover:underline">{t.policy}</Link>
          <Link to="/services/evadagai" className="cursor-pointer hover:underline">{t.services}</Link>
          <Link to="/kcc" className="cursor-pointer hover:underline">{t.schemes}</Link>
        </div>

        {/* Center - Location */}
        <div className="flex flex-col space-y-3 text-center mx-auto">
          <h2 className="font-semibold mb-3">{t.location}</h2>
          <p className="text-sm">{t.locationAddress}</p>
          <a 
            href="https://www.google.com/maps/place/RCS+Office/@13.0754509,80.2374874,17z/data=!3m1!4b1!4m6!3m5!1s0x3a5267001169a263:0x3ba2961806753460!8m2!3d13.0754509!4d80.2400623!16s%2Fg%2F11x7bg_t0b?entry=ttu&g_ep=EgoyMDI2MDEwNy4wIKXMDSoKLDEwMDc5MjA3M0gBUAM%3D" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-sm hover:underline font-semibold"
          >
            {t.viewOnMap}
          </a>
        </div>

        {/* Right - Social Media */}
        <div className="flex flex-col space-y-3 mx-auto">
          <h2 className="font-semibold mb-3 text-center">{t.socialMedia}</h2>
          <a 
            href="https://twitter.com/tncoopdept" 
            target="_blank" 
            rel="noopener noreferrer"
            className="flex items-center space-x-2 hover:underline text-left"
          >
            <Twitter size={18} /> <span>{t.twitter}</span>
          </a>
          <a 
            href="https://www.instagram.com/tncoopdept/?igsh=dmkyeWdlZ2x2NWhl#" 
            target="_blank" 
            rel="noopener noreferrer"
            className="flex items-center space-x-2 hover:underline text-left"
          >
            <Instagram size={18} /> <span>{t.instagram}</span>
          </a>
          <a 
            href="https://www.youtube.com/@tncoopdept" 
            target="_blank" 
            rel="noopener noreferrer"
            className="flex items-center space-x-2 hover:underline text-left"
          >
            <Youtube size={18} /> <span>{t.youtube}</span>
          </a>
          <a 
            href="https://www.facebook.com/tncoopdept" 
            target="_blank" 
            rel="noopener noreferrer"
            className="flex items-center space-x-2 hover:underline text-left"
          >
            <Facebook size={18} /> <span>{t.facebook}</span>
          </a>
          <a 
            href="https://whatsapp.com/channel/0029Vb6POeTGE56dJATiYc2v" 
            target="_blank" 
            rel="noopener noreferrer"
            className="flex items-center space-x-2 hover:underline text-left"
          >
            <FaWhatsapp size={18} /> <span>{t.whatsapp}</span>
          </a>
        </div>
      </div>

      {/* Bottom Copyright */}
      <div className="text-center py-4 border-t border-white/20">
        {/* Visitor Counter */}
        <div className="flex items-center justify-center mb-3">
          <img
            src="https://hits.sh/kooturavu.tn.gov.in/visits.svg?style=flat-square&label=Total+Visitors&color=006AA5&labelColor=004d7a"
            alt="Total Visitors"
          />
        </div>

        <p className="text-sm">
          {t.copyright}
        </p>
        <p className="text-xs mt-2">
          {t.designedBy}{" "}
          <a
            href="https://www.klabsindia.com"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:underline font-semibold"
          >
            klabsindia.com
          </a>
        </p>
      </div>
    </footer>
  );
};

export default Footer;